import FormItem from '@/components/Common/FormItem/FormItem';
import COLORS from '@/constants/colors';
import { FORMAT_DATE_1 } from '@/utils/dateTime';
import { Box, OutlinedInput, Paper, Stack, Typography } from '@mui/material';
import {
  DigitalClock,
  MobileDatePicker,
  MobileTimePicker,
} from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { SellerLineUi } from '../CartUiModel';

export const SellerTicket = (props: {
  sellerTicketUi: SellerLineUi;
  onChangeDeliveryDate: (sellerId: string, newValue: Dayjs | null) => void;
  onStartTimeChange: (sellerId: string, newValue: Dayjs | null) => void;
  onEndTimeChange: (sellerId: string, newValue: Dayjs | null) => void;
  onChangeDeliveryNotes: (sellerId: string, newValue: string) => void;
}) => {
  const subtitleStyle = {
    fontWeight: 500,
    color: COLORS.gray_800,
    fontSize: '12px',
  };

  return (
    <Paper
      key={props.sellerTicketUi.id}
      sx={{ display: 'flex', flexDirection: 'column', boxShadow: 'none' }}
    >
      <Box
        style={{
          lineHeight: '1.5',
          color: COLORS.gray_800,
          fontSize: '12px',
          fontWeight: 700,
          marginBottom: '12px',
        }}
      >
        {props.sellerTicketUi.name}
      </Box>
      <Typography variant="body1" sx={subtitleStyle}>
        Mínimo de compra: ${props.sellerTicketUi.minimumOrderAmount}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginTop: '16px',
        }}
      >
        <Typography variant="body1" sx={subtitleStyle}>
          Total de vendedor
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 500,
            color: COLORS.gray_800,
            fontSize: '12px',
          }}
        >
          ${props.sellerTicketUi.total}
        </Typography>
      </Box>
      <Stack sx={{ mt: '16px' }} spacing={'12px'}>
        <Stack direction={'row'} spacing={'12px'}>
          <Stack flexGrow={1}>
            <Typography variant="body1" sx={subtitleStyle}>
              Fecha de entrega
            </Typography>

            <FormItem helperText={props.sellerTicketUi.deliveryDateError}>
              <MobileDatePicker
                sx={{ width: '100%' }}
                format={FORMAT_DATE_1}
                closeOnSelect
                value={props.sellerTicketUi.deliveryDate}
                onChange={(newDate) =>
                  props.onChangeDeliveryDate(props.sellerTicketUi.id, newDate)
                }
                slotProps={{
                  textField: {
                    inputProps: { readOnly: true },
                    error: !!props.sellerTicketUi.deliveryDateError,
                  },
                }}
                minDate={dayjs()}
              />
            </FormItem>
          </Stack>
          <Stack flexGrow={1}>
            <Typography variant="body1" sx={subtitleStyle}>
              Hora Inicio
            </Typography>
            <FormItem>
              <MobileTimePicker
                sx={{ width: '100%' }}
                value={props.sellerTicketUi.deliveryStartTime}
                ampm={false}
                views={['hours']}
                format="HH:00"
                closeOnSelect
                viewRenderers={{
                  hours: (props) => <DigitalClock {...props} skipDisabled />,
                }}
                minutesStep={60}
                onChange={(newValue) =>
                  props.onStartTimeChange(props.sellerTicketUi.id, newValue)
                }
                slotProps={{
                  textField: {
                    inputProps: { readOnly: true },
                    error: !!props.sellerTicketUi.deliveryTimeError,
                    placeholder: 'Rango inicio',
                  },
                }}
              />
            </FormItem>
          </Stack>
          <Stack flexGrow={1}>
            <Typography variant="body1" sx={subtitleStyle}>
              Hora Final
            </Typography>
            <FormItem helperText={props.sellerTicketUi.deliveryTimeError}>
              <MobileTimePicker
                sx={{ width: '100%' }}
                value={props.sellerTicketUi.deliveryEndTime}
                ampm={false}
                views={['hours']}
                format="HH:00"
                closeOnSelect
                viewRenderers={{
                  hours: (props) => <DigitalClock {...props} skipDisabled />,
                }}
                minutesStep={60}
                onChange={(newValue) =>
                  props.onEndTimeChange(props.sellerTicketUi.id, newValue)
                }
                slotProps={{
                  textField: {
                    inputProps: { readOnly: true },
                    error: !!props.sellerTicketUi.deliveryTimeError,
                    placeholder: 'Rango final',
                  },
                }}
              />
            </FormItem>
          </Stack>
        </Stack>
        <Stack>
          <Typography variant="body1" sx={subtitleStyle}>
            Notas de entrega
          </Typography>
          <OutlinedInput
            placeholder={'Agregar notas para el vendedor aquí ...'}
            value={props.sellerTicketUi.deliveryNotes}
            onChange={(e) =>
              props.onChangeDeliveryNotes(
                props.sellerTicketUi.id,
                e.target.value
              )
            }
          />
        </Stack>
      </Stack>
    </Paper>
  );
};
